import { defineComponent, openBlock, createElementBlock, createStaticVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "ArrowRight"
});
const _hoisted_1 = {
  width: "12px",
  height: "12px",
  viewBox: "0 0 12 12",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-1055.000000, -1971.000000)"><g transform="translate(835.000000, 1951.000000)"><g transform="translate(220.000000, 20.000000)"><rect x="0" y="0" width="12" height="12"></rect><path d="M3.25028996,1.99445096 L7.105545,5.99986077 L3.25023098,10.005332 C3.11050145,10.1505037 3.11046817,10.3801462 3.25015563,10.5253585 L3.67703476,10.969121 C3.82061449,11.1183795 4.05800672,11.122983 4.20726516,10.9794032 L8.74979673,6.25983725 C8.88951291,6.11466361 8.88953993,5.88503193 8.74985794,5.7398254 L8.0527725,5.01516972 L4.21742358,1.03087489 C4.08484103,0.8931435 3.872366,0.878695886 3.72310511,0.990257898 L3.68207731,1.02579136 L3.25027583,1.47436083 C3.11053046,1.6195648 3.1105367,1.84925458 3.25028996,1.99445096 Z" fill="#42526E"></path></g></g></g></g>', 1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var arrowRight = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { arrowRight as default };
